import React, { FC, useMemo } from "react";
import { objectToClassString } from "../../utils/functions";
import "./CustomSwitch.scss";

interface ICustomSwitch {
  value?: boolean | undefined;
  onChange: (value: boolean) => void;
  className?: string;
}

const CustomSwitch: FC<ICustomSwitch> = ({
  value = false,
  onChange,
  className = "",
}) => {
  const customSwitchMemo = useMemo(
    () => (
      <div
        className={`custom__switch__input ${className} ${objectToClassString({
          active: value,
        })}`}
        onClick={() => onChange(!value)}
      >
        <div className="circle"></div>
      </div>
    ),
    // eslint-disable-next-line
    [value]
  );

  return <>{customSwitchMemo}</>;
};

export default CustomSwitch;
